import React, { useContext, useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ThemeContext } from 'src/providers/themeProvider';

const CustomTooltip = ({
    title,
    placement,
    children,
    hideTooltip = false,
    showArrow = true,
    maxWidth = null,
    maxHeight = null,
    overflowY = null,
    customStyle = {},
    wrapperStyle = {},
    wrapperClassName = ''
}) => {
    const theme = useContext(ThemeContext);

    return (
        <Tooltip
            className={wrapperClassName}
            title={title}
            placement={placement}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: theme[0].theme === 'DARK' ? '#525252' : '#fff',
                        color: theme[0].theme === 'DARK' ? '#fff' : '#000',
                        fontSize: '12px',
                        padding: '10px',
                        boxShadow: '0px 4px 15px 0px #00000026',
                        borderRadius: '8px',
                        lineHeight: '15px',
                        fontWeight: '400',
                        fontFamily: 'Open Sans, sans-serif',
                        ...(maxWidth && { maxWidth: maxWidth }),
                        ...(maxHeight && { maxHeight: maxHeight }),
                        ...(overflowY && { overflowY: overflowY }),
                        ...(customStyle && { ...customStyle })
                    },
                },
                arrow: {
                    sx: {
                        color: theme[0].theme === 'DARK' ? '#fff' : '#525252',
                        display: showArrow ? 'block' : 'none',
                    },
                },
            }}
            arrow={showArrow}
            arrowProps={{
                sx: {
                    color: theme[0].theme === 'DARK' ? '#fff' : '#525252',
                },
            }}
            style={{
                display: hideTooltip ? 'none' : undefined,
                ...wrapperStyle
            }}
        >
            {children}
        </Tooltip>
    );
};


export const ScrollAwareTooltip = ({ title, placement, children, hideTooltip = false, showArrow = true }) => {
    const [open, setOpen] = useState(false);
    const theme = React.useContext(ThemeContext);

    useEffect(() => {
        if (open) {
            const handleScroll = () => {
                setOpen(false);
            };
            
            const scrollContainer = document.querySelector('.rules-creation-panel-listing-table');
            const scrollTarget = scrollContainer || window;
            
            scrollTarget.addEventListener('scroll', handleScroll, true);
            
            return () => {
                scrollTarget.removeEventListener('scroll', handleScroll, true);
            };
        }
    }, [open]);


    return (
        <Tooltip
            title={title}
            placement={placement}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            PopperProps={{
                disablePortal: true,
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      boundary: 'scrollParent', // or 'clippingParents'
                    },
                  },
                ],
              }}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: theme[0].theme === 'DARK' ? '#525252' : '#fff',
                        color: theme[0].theme === 'DARK' ? '#fff' : '#000',
                        fontSize: '12px',
                        padding: '10px',
                        boxShadow: '0px 4px 15px 0px #00000026',
                        borderRadius: '8px',
                        lineHeight: '15px',
                        fontWeight: '400',
                        fontFamily: 'Open Sans, sans-serif'
                    },
                },
                arrow: {
                    sx: {
                        color: theme[0].theme === 'DARK' ? '#fff' : '#525252',
                        display: showArrow ? 'block' : 'none',
                    },
                },
            }}
            arrow={showArrow}
            arrowProps={{
                sx: {
                    color: theme[0].theme === 'DARK' ? '#fff' : '#525252',
                },
            }}
            style={{
                display: hideTooltip ? 'none' : undefined,
            }}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;
